var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodejsPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4419 25.501L29.4419 8.50103L14.7209 0.006836L3.18251e-08 8.50103L9.55189e-08 25.501L14.7209 34.001L29.4419 25.501Z",
    fill: "#3B8739"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7151 5.76016e-08L29.4361 25.4942L14.7151 33.9942L3.18469e-08 8.50001L14.7151 5.76016e-08Z",
    fill: "#6DA75D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36938e-08 25.5L5.05233 17.2558L0 8.5L6.36938e-08 25.5Z",
    fill: "#55A344"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5298 17.001L29.4368 8.50103L14.7217 0.00683594L24.5298 17.001Z",
    fill: "#639D57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejsPlatform);
export default __webpack_public_path__ + "static/media/nodejs-platform.741232e0dcfee015621835de7d58d6cc.svg";
export { ForwardRef as ReactComponent };